export const version1Stores = {
  profiles: "&id",
  settings: "&id",
  goalPhases: "&id, effectiveFrom, mode",
  nutrientGoals: "&id, &nutrientKey",
  foods: "&id, name, brand, barcode, updatedAt, [source.provider+source.externalId]",
  diaryEntries: "&id, date, createdAt, food.foodId, [date+createdAt]",
  weightEntries: "&date, recordedAt",
  onboardingReferences: "&id",
  weekPlans: "&id, startDate, endDate, status",
  checkIns: "&id, completedAt, completedDate, weekPlanId",
  backupState: "&id",
  metadata: "&key",
} as const;
